var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "base-card",
        { attrs: { overflowVisible: "" } },
        [
          _c("h3", {
            staticClass: "text-center mb-4",
            domProps: { innerHTML: _vm._s(_vm.$t("medicationReminder")) }
          }),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "justify-content-center mb-4" },
            [
              _c(
                "b-col",
                { attrs: { cols: "12", xl: "6" } },
                [
                  _c("base-select", {
                    attrs: {
                      searchable: "",
                      loading: _vm.medicine.loading,
                      options: _vm.medicine.options,
                      label: "name",
                      valueProp: "id",
                      placeholder: _vm.$t("enterMedicineName")
                    },
                    on: {
                      search: function($event) {
                        return _vm.searchMedicine($event)
                      },
                      "option:selected": _vm.onMedicineSelected
                    },
                    model: {
                      value: _vm.medicine.value,
                      callback: function($$v) {
                        _vm.$set(_vm.medicine, "value", $$v)
                      },
                      expression: "medicine.value"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.medicine.value
            ? _c(
                "div",
                [
                  _c(
                    "b-row",
                    { staticClass: "justify-content-center mt-5" },
                    [
                      _c("b-col", { attrs: { cols: "12" } }, [
                        _c("h5", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("reminderMedicationForm.frequencyTitle")
                            )
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "text-center", attrs: { cols: "12" } },
                        [
                          _c("base-radio-group", {
                            attrs: { options: _vm.reminderFrequency.options },
                            on: { input: _vm.onReminderChange },
                            model: {
                              value: _vm.reminderFrequency.value,
                              callback: function($$v) {
                                _vm.$set(_vm.reminderFrequency, "value", $$v)
                              },
                              expression: "reminderFrequency.value"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.reminderFrequency.value === _vm.INTERVAL_FREQUENCY_OPTION
                    ? _c(
                        "b-row",
                        { staticClass: "justify-content-center row-gap" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "3", xl: "2" } },
                            [
                              _c("base-input", {
                                attrs: {
                                  type: "number",
                                  min: 1,
                                  max: _vm.hoursIntervalSelected ? 23 : 90
                                },
                                on: {
                                  input: _vm.updateIntervalEndHoursOptions
                                },
                                model: {
                                  value: _vm.reminderFrequency.interval.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.reminderFrequency.interval,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "reminderFrequency.interval.value"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "mb-4",
                              attrs: { cols: "12", md: "3", xl: "2" }
                            },
                            [
                              _c("base-select", {
                                attrs: {
                                  loading: false,
                                  options:
                                    _vm.reminderFrequency.interval.options,
                                  label: "name",
                                  valueProp: "value",
                                  placeholder: _vm.$t(
                                    "reminderMedicationForm.option"
                                  )
                                },
                                model: {
                                  value:
                                    _vm.reminderFrequency.interval.optionValue,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.reminderFrequency.interval,
                                      "optionValue",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "reminderFrequency.interval.optionValue"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.reminderFrequency.value ===
                  _vm.SEVERAL_TIMES_DAY_FREQUENCY_OPTION
                    ? _c(
                        "b-row",
                        { staticClass: "justify-content-center row-gap" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "5", md: "3", xl: "2" } },
                            [
                              _c("base-input", {
                                attrs: { type: "number", min: 2, max: 10 },
                                on: { input: _vm.onReminderChange },
                                model: {
                                  value:
                                    _vm.reminderFrequency.severalTimesDay.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.reminderFrequency.severalTimesDay,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "reminderFrequency.severalTimesDay.value"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "vertical-align",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("reminderMedicationForm.tabletsDay")
                              )
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.reminderFrequency.value === _vm.WEEK_DAYS_FREQUENCY_OPTION
                    ? _c(
                        "b-row",
                        { staticClass: "justify-content-center row-gap" },
                        [
                          _c("b-col", { attrs: { cols: "12" } }, [
                            _c("h5", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t(
                                    "reminderMedicationForm.selectWeekDays"
                                  )
                                )
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "text-center",
                              attrs: { cols: "12" }
                            },
                            [
                              _c("b-form-checkbox-group", {
                                staticClass: "form-group",
                                attrs: {
                                  options:
                                    _vm.reminderFrequency.weekDays.options,
                                  "value-field": "value",
                                  "text-field": "name"
                                },
                                model: {
                                  value: _vm.reminderFrequency.weekDays.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.reminderFrequency.weekDays,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "reminderFrequency.weekDays.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.reminderFrequency.value === _vm.CYCLIC_FREQUENCY_OPTION
                    ? _c(
                        "b-row",
                        { staticClass: "justify-content-center row-gap" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "5", md: "6", xl: "2" } },
                            [
                              _c("base-input", {
                                attrs: { type: "number", min: 1 },
                                model: {
                                  value: _vm.reminderFrequency.cyclic.tablets,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.reminderFrequency.cyclic,
                                      "tablets",
                                      $$v
                                    )
                                  },
                                  expression: "reminderFrequency.cyclic.tablets"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "vertical-align",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("reminderMedicationForm.intakes")
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "5", md: "6", xl: "2" } },
                            [
                              _c("base-input", {
                                attrs: { type: "number", min: 1 },
                                model: {
                                  value: _vm.reminderFrequency.cyclic.pauses,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.reminderFrequency.cyclic,
                                      "pauses",
                                      $$v
                                    )
                                  },
                                  expression: "reminderFrequency.cyclic.pauses"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "vertical-align",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("reminderMedicationForm.pauses")
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("b-col", { attrs: { cols: "12" } }, [
                            _c("h5", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("reminderMedicationForm.startDate")
                                )
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "12", xl: "6" } },
                            [
                              _c("base-datepicker", {
                                attrs: { dateAfterNow: "" },
                                model: {
                                  value: _vm.reminderFrequency.cyclic.startDate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.reminderFrequency.cyclic,
                                      "startDate",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "reminderFrequency.cyclic.startDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.reminderFrequency.value === _vm.INTERVAL_FREQUENCY_OPTION
                    ? _c(
                        "b-row",
                        { staticClass: "justify-content-center row-gap" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "3", xl: "2" } },
                            [
                              _c("span", {
                                staticClass: "block-center",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("reminderMedicationForm.tablets")
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c("base-input", {
                                attrs: { type: "number", min: 1 },
                                model: {
                                  value: _vm.medicine.tabletsOptions[0].value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.medicine.tabletsOptions[0],
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "medicine.tabletsOptions[0].value"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "mb-4",
                              attrs: { cols: "12", md: "4", xl: "2" }
                            },
                            [
                              _c("span", {
                                staticClass: "block-center",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("reminderMedicationForm.startHour")
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c("base-timepicker", {
                                attrs: {
                                  noMarginBottom: "",
                                  buttonOnly: "",
                                  placeholder:
                                    "" +
                                    _vm.$t("reminderMedicationForm.fromHour")
                                },
                                on: {
                                  input: _vm.updateIntervalEndHoursOptions
                                },
                                model: {
                                  value:
                                    _vm.medicine.tabletsOptions[0].startHour,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.medicine.tabletsOptions[0],
                                      "startHour",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "medicine.tabletsOptions[0].startHour"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.hoursIntervalSelected
                            ? _c(
                                "b-col",
                                {
                                  staticClass: "mb-4",
                                  attrs: { cols: "12", md: "3", xl: "2" }
                                },
                                [
                                  _c("span", {
                                    staticClass: "block-center",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t("reminderMedicationForm.endHour")
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("base-select", {
                                    attrs: {
                                      avoidDefaultSort: "",
                                      noMarginBottom: "",
                                      buttonOnly: "",
                                      options:
                                        _vm.reminderFrequency.interval
                                          .endHoursOptions,
                                      label: "value",
                                      valueProp: "value",
                                      placeholder:
                                        "" +
                                        _vm.$t("reminderMedicationForm.toHour")
                                    },
                                    model: {
                                      value:
                                        _vm.medicine.tabletsOptions[0].endHour,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.medicine.tabletsOptions[0],
                                          "endHour",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "medicine.tabletsOptions[0].endHour"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showTabletsSection
                    ? _c(
                        "div",
                        _vm._l(_vm.medicine.tabletsOptions, function(
                          item,
                          index
                        ) {
                          return _c(
                            "b-row",
                            {
                              key: "tablets" + index,
                              staticClass: "justify-content-center row-gap"
                            },
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12", md: "4", xl: "2" } },
                                [
                                  _c("span", {
                                    staticClass: "block-center",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.$t("hour"))
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("base-timepicker", {
                                    attrs: {
                                      noMarginBottom: "",
                                      buttonOnly: "",
                                      placeholder: _vm.$t(
                                        "reminderMedicationForm.hourTitle"
                                      )
                                    },
                                    model: {
                                      value: item.startHour,
                                      callback: function($$v) {
                                        _vm.$set(item, "startHour", $$v)
                                      },
                                      expression: "item.startHour"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "12", md: "3", xl: "2" } },
                                [
                                  _c("span", {
                                    staticClass: "block-center",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t("reminderMedicationForm.tablets")
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("base-input", {
                                    attrs: { type: "number", min: 1 },
                                    model: {
                                      value: item.value,
                                      callback: function($$v) {
                                        _vm.$set(item, "value", $$v)
                                      },
                                      expression: "item.value"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "justify-content-center row-gap mt-5" },
                    [
                      _c("b-col", { attrs: { cols: "12" } }, [
                        _c("h5", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t(
                                "reminderMedicationForm.reminderFillQuestion"
                              )
                            )
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "text-center", attrs: { cols: "12" } },
                        [
                          _c("binary-radio-group", {
                            attrs: { noMarginTop: "" },
                            model: {
                              value: _vm.tabletsReminder.enabled,
                              callback: function($$v) {
                                _vm.$set(_vm.tabletsReminder, "enabled", $$v)
                              },
                              expression: "tabletsReminder.enabled"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.tabletsReminder.enabled
                    ? _c(
                        "b-row",
                        { staticClass: "justify-content-center row-gap" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "3", xl: "2" } },
                            [
                              _c("base-input", {
                                attrs: { type: "number", min: 1 },
                                model: {
                                  value: _vm.tabletsReminder.left,
                                  callback: function($$v) {
                                    _vm.$set(_vm.tabletsReminder, "left", $$v)
                                  },
                                  expression: "tabletsReminder.left"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "vertical-align",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "reminderMedicationForm.reminderMedicineTitle"
                                )
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "3", xl: "2" } },
                            [
                              _c("base-input", {
                                attrs: {
                                  type: "number",
                                  min: 0,
                                  max: _vm.tabletsReminder.left
                                    ? _vm.tabletsReminder.left - 1
                                    : null
                                },
                                model: {
                                  value: _vm.tabletsReminder.limit,
                                  callback: function($$v) {
                                    _vm.$set(_vm.tabletsReminder, "limit", $$v)
                                  },
                                  expression: "tabletsReminder.limit"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "vertical-align",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("reminderMedicationForm.units")
                              )
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "justify-content-center row-gap mt-5" },
                    [
                      _c("b-col", { attrs: { cols: "12" } }, [
                        _c("h5", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t(
                                "reminderMedicationForm.notificationsQuestion"
                              )
                            )
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "base-checkbox",
                            {
                              staticClass: "inline-block",
                              staticStyle: { "margin-right": "3rem" },
                              model: {
                                value: _vm.notifications.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.notifications, "email", $$v)
                                },
                                expression: "notifications.email"
                              }
                            },
                            [_vm._v("Email")]
                          ),
                          _vm._v(" "),
                          _c(
                            "base-checkbox",
                            {
                              staticClass: "inline-block",
                              model: {
                                value: _vm.notifications.whatsapp,
                                callback: function($$v) {
                                  _vm.$set(_vm.notifications, "whatsapp", $$v)
                                },
                                expression: "notifications.whatsapp"
                              }
                            },
                            [_vm._v("Whatsapp")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "justify-content-center mt-5" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12", xl: "6" } },
                        [
                          _c("base-textarea", {
                            attrs: {
                              placeholder:
                                _vm.$t("notes") + " " + _vm.$t("optional")
                            },
                            model: {
                              value: _vm.notes,
                              callback: function($$v) {
                                _vm.notes = $$v
                              },
                              expression: "notes"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text-center mt-5" },
                    [
                      _c("base-button", { on: { click: _vm.save } }, [
                        _vm._v(_vm._s(_vm.$t("save-btn")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "base-button",
                        {
                          attrs: { gray: "" },
                          on: {
                            click: function($event) {
                              return _vm.$emit("onShowReminderMenu")
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("cancel-btn")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bde41ae2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bde41ae2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/clinicHistory/medicationReminder/MedicationReminderForm.vue
// module id = 3847
// module chunks = 5